import { createGlobalStyle } from 'styled-components';
import { globalStylesPropTypes } from './GlobalStyles.types';
export const GlobalStyles = createGlobalStyle `
  @font-face {
    font-weight: 400 700;
    font-family: 'AudiType';
    font-style: normal;
    font-stretch: 100% 130%;
    src: url('https://assets.audi.com/audi-fonts/1/AudiTypeVF.woff2')
      format('woff2-variations');
    font-display: swap;
  }
`;
GlobalStyles.propTypes = globalStylesPropTypes;
//# sourceMappingURL=GlobalStyles.js.map